import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { BaseRichService } from '../../../providers/base-rich.service';
import { ListComponent } from '../../shared/list/list.component';
import { InvoiceFormComponent } from '../invoice-form/invoice-form.component';
import { InvoiceLogComponent } from '../invoice-log/invoice-log.component';

@Component({
  selector: 'app-invoice-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./invoice-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class InvoiceListComponent extends ListComponent implements OnInit {
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.entity = 'invoice';
    this.form = InvoiceFormComponent;
  }

  getBody(): any {
    const body = super.getBody();
    let query = ['status', '<>', 'D'] as any;
    if (this.selectedAccount) {
      body.mode = 'user';
      query = [
        ['account_id', '=', this.selectedAccount],
        'and',
        query
      ];
    }
    if (body.query) {
      body.query = [body.query, 'and', query];
    } else {
      body.query = query;
    }
    return body;
  }

  async perform(action, row) {
    return new Promise(async (resolve, reject) => {
      try {
        switch (action.name.toLowerCase()) {
          case 'pay':
            this.service.perform(this.entity, action.name, row).subscribe((result: any) => {
              if (result.credit) {
                this.handleSuccess();
              } else if (result.gate) {
                if (result.redirectUrl) {
                  window.location.href = result.redirectUrl;
                } else {
                  this.handleError({ message: this.translator.instant('GATE_EMPTY_REDIRECT') });
                }
              } else {
                this.handleError({ message: this.translator.instant('GATE_EMPTY') });
              }
            }, error => {
              this.handleError(error);
            });
            break;

          case 'print':
            this.service.perform(this.entity, action.name, row, { responseType: 'blob' }).subscribe(async (blob: Blob) => {
              const url = window.URL.createObjectURL(blob);

              const a =
                document.createElement('a');

              a.href = url;
              a.download = `${this.translator.instant('INVOICE')}-${row.legal_no || row.id}.pdf`;

              a.click();

              window.URL.revokeObjectURL(url);
              /*
              const newWindow = window.open('', '_blank');

              if (newWindow) {
                newWindow.document.write(`
                  <!DOCTYPE html>
                  <html>
                  <head>
                      <title>${this.translator.instant('INVOICE')}-${row.id}</title>
                  </head>
                  <body style="margin:0">
                      <iframe
                          src="${url}"
                          style="width:100%; height:100vh; border:0;">
                      </iframe>
                  </body>
                  </html>
              `);

                newWindow.document.close();
              }
                */
              resolve(true);
            }, error => {
              this.handleError(error);
            });
            break;
          case 'log':
            const log = this.activeModal.open(InvoiceLogComponent, { size: 'lg' });
            log.componentInstance.invoiceId = row.id;
            resolve(true);
            break;
          default:
            await super.perform(action, row);
            resolve(true);
            break;
        }
      } catch (error) {
        reject(error);
      }
    });

  }
}
